import React from 'react';
import { TypeCard } from '../../../../components/TypeCard';
import { Resources } from '../../../../models/ScheduleResource';
import { serviceIconsList } from '../../../../utils/constants/productCategoryIcon';
const stethoscopeIcon =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/services/estetoscopio.svg';

type ServicesType = {
  serviceList: Resources[];
  selectedService: Resources;
  handleSelectService: (service: Resources) => void;
};

export const Services: React.FC<ServicesType> = ({ serviceList, selectedService, handleSelectService }) => {
  function getIconName(serviceName: string) {
    const lowerCaseServiceName = serviceName.toLowerCase();
    return serviceIconsList.find(item => lowerCaseServiceName.includes(item.name))?.icon || stethoscopeIcon;
  }

  const serviceDescriptions = [
    { name: 'equipe do cuidado', description: 'Consultas Clínicas Einstein' },
    { name: 'imunização', description: 'Vacinas' },
    { name: 'médicos', description: 'Consulte por médicos ou especialidades' },
    { name: 'pcr', description: 'Exames' },
    { name: 'telemedicina', description: 'Consulta virtual' },
    { name: 'atenção primária', description: 'Agendamentos de consulta com a equipe do cuidado' },
    { name: 'ocupacional', description: 'Exclusivo para colaborador Einstein' },
    { name: 'trabalho', description: 'Exclusivo para colaborador Einstein' },
    { name: 'sangue', description: '' },
    {
      name: 'check-up digital',
      description: 'Consultas de telemedicina com profissionais Einstein'
    },
    {
      name: 'check-up executivo',
      description: 'Consultas de retorno para o check-up executivo'
    },
    {
      name: 'check-up executivo0',
      description: 'Consultas de retorno para o check-up executivo'
    }
  ];

  function getDescriptionName(serviceName: string): string {
    const lowerCaseServiceName = serviceName.toLowerCase();
    return serviceDescriptions.find(item => lowerCaseServiceName.includes(item.name))?.description || '';
  }

  return (
    <>
      {serviceList.map(service => (
        <TypeCard
          key={service.id}
          id={`#item-result-${service.id}`}
          title={service.name}
          description={getDescriptionName(service.name)}
          iconSrc={getIconName(service.name)}
          onClick={() => handleSelectService(service)}
          checked={selectedService ? selectedService.id === service.id : false}
        />
      ))}
    </>
  );
};
